export let SortOrders = /*#__PURE__*/function (SortOrders) {
  SortOrders["Custom"] = "custom";
  SortOrders["Relevance"] = "relevance";
  SortOrders["Date"] = "date";
  SortOrders["Name"] = "name";
  return SortOrders;
}({});
//# sourceMappingURL=sort-orders.js.map